import Component from './Configurator.vue';

export default {
  install(Vue) {
    Vue.component('BkfConfiguratorDialog', Component);
  },
};
